import React from 'react';
import { BookingsFilter } from 'acscp/store';
import { FormattedMessage } from 'react-intl';

export function formatBookingsFilter(filter: BookingsFilter): JSX.Element | null {
    switch (filter) {
        case BookingsFilter.Enquiries:
            return <FormattedMessage id={'bookingFilter.Enquiries'} defaultMessage={'Enquiries'} />;
        case BookingsFilter.Quoted:
            return <FormattedMessage id={'bookingFilter.Quoted'} defaultMessage={'Quotes'} />;
        case BookingsFilter.Booked:
            return <FormattedMessage id={'bookingFilter.Booked'} defaultMessage={'Bookings'} />;
        case BookingsFilter.Flown:
            return <FormattedMessage id={'bookingFilter.Flown'} defaultMessage={'Flown'} />;
        // The following filters are NOT supposed to be displayed anywhere in the app (only used for filtering),
        // so we return nothing, just in case.
        case BookingsFilter.ItineraryAvailable:
            if (process.env.NODE_ENV === 'development') {
                throw new Error(`'${filter}' bookings filter does not have visual representation.`);
            }

            return null;
    }
}
